<div>
  <div *ngFor="let translation of displayedResult">
    <b>{{ translation[0] | titlecase}}:</b> {{ translation[1] }}
  </div>
</div>